import { Slot } from '@radix-ui/react-slot';
import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/cn';
import { type CardVariants, cardVariants } from './card-variants';

type CardProps = ComponentProps<'div'> & CardVariants & { asChild?: boolean };

export function Card({ asChild = false, isInteractive, className, ...props }: CardProps) {
  const Comp = asChild ? Slot : 'div';
  return (
    <Comp data-slot="card" className={cn(cardVariants({ isInteractive }), className)} {...props} />
  );
}
